import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  conditionInfo,
  createGUID,
  feverInfo,
  messagesMock,
  navigateToSection,
} from './mockedMessages';
import { IcareMessage, MessageType } from './model';

export interface IcareState {
  messages: IcareMessage[];
  searchMessages: IcareMessage[];
}

const initialState: IcareState = {
  messages: messagesMock,
  searchMessages: [],
};

const icareSlice = createSlice({
  name: 'icare',
  initialState,
  reducers: {
    addMessage: (
      state,
      action: PayloadAction<{
        messageText?: string;
      }>
    ) => {
      const newMessage: IcareMessage = {
        id: createGUID(),
        messageText: action.payload.messageText,
        picUrl: '',
        senderId: 'me',
        messageType: MessageType.text,
        dateCreated: new Date().toUTCString(),
      };
      state.messages.push(newMessage);
    },
    addIcareMessage: (
      state,
      action: PayloadAction<{
        messageText?: string;
      }>
    ) => {
      if (action.payload.messageText?.toLowerCase().includes('navigate')) {
        state.messages.push(...navigateToSection);
      }
      if (action.payload.messageText?.toLowerCase().includes('condition')) {
        state.messages.push(...conditionInfo);
      }
      if (action.payload.messageText?.toLowerCase().includes('headache')) {
        state.messages.push(...feverInfo);
      }
    },
    setUserInteracted: (state, action: PayloadAction<string>) => {
      const index = state.messages.findIndex((el) => el.id === action.payload);
      state.messages[index].clicked = true;
    },
    searchMessage: (
      state,
      action: PayloadAction<{
        searchString: string;
      }>
    ) => {
      const result = state.messages.filter((item) =>
        item.messageText
          ?.toLowerCase()
          .includes(action.payload.searchString.toLowerCase())
      );
      state.searchMessages = result;
    },
    clearSearch: (state) => {
      state.searchMessages = [];
    },
  },
  extraReducers: (builder) => {},
});

export const {
  addMessage,
  addIcareMessage,
  searchMessage,
  clearSearch,
  setUserInteracted,
} = icareSlice.actions;

export default icareSlice.reducer;
